<section class="p-2 p-md-4">

  <div class="card mb-4">
    <div class="col-12 p-3">
      <div class="d-flex flex-column">
        <label for="unidade">Unidades atendidas</label>
        <select class="form-control input-validate" name="unidade" [formControl]="form.unidade">
          <option *ngFor="let u of listaUnidades" [value]="u.id">{{u.nomeFantasia}}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="card mb-4" *ngIf="pontosAtendimento">
    <div class="table-responsive">

      <div class="row">
        <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="pontosAtendimento" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
          [(selection)]="pontoAtendimento" [first]="first">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
              </th>
              <th style="width: 10%;" class="text-center">Ações</th>

            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td>{{ rowData.nomePontoAtendimento }}</td>
              <td>{{ rowData.documentoPontoAtendimento }}</td>
              <td>{{ rowData.telefonePontoAtendimento }}</td>
              <td class="py-1">
                <div class="d-flex align-items-center justify-content-center">
                  <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button class="btn btn-sm btn-icon btn-danger" (click)="delPontoAtendimento(rowData.id)">
                    <i class="mdi mdi-delete"></i>
                  </button>
                  </span>
                </div>
              </td>

            </tr>
            
          </ng-template>

          <ng-template pTemplate="caption" let-columns>
            <tr>
              <td class="fw-700" style="text-align: right;">Novo ponto de atendimento</td>
              <td class="w-25">
                <select class="form-control input-validate" name="atendimento" id="atendimento" [formControl]="form.atendimento">
                  <option *ngFor="let p of listaPontosAtendimentos" [value]="p.id">{{p.nomeFantasia}}</option>
                </select>
              </td>
              <td style="width: 10%;">
                <div class="d-flex align-items-center justify-content-start">
                  <button class="btn btn-md btn-success btn-icon w-100" (click)="addPontoAtendimento()">
                    Adicionar
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhum resultado foi encontrado
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div *ngIf="!pontosAtendimento" class="card">
    <div class="f-16 text-muted card-body">Selecione uma unidade</div>
  </div>

</section>